const key = 'lastRoute';

export const setLastRoute = (newRoute: string): any =>
	localStorage.setItem(key, newRoute);

export const removeLastRoute = (): any => localStorage.removeItem(key);

export const getLastRoute = (): string | null => localStorage.getItem(key);
